module.exports = __webpack_public_path__ + "media/images/svgs/jobs/web-b1e23ff4509ffd3e8c6558987de20842.svg";